import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    public storage: Storage
  ) { }

  add(key, obj) {
    return this.storage.set(key, obj);
  }

  get(key) {
    return this.storage.get(key);
  }

  remove(keys) {
    keys.forEach(key => {
      return this.storage.remove(key)
    });
  }

  addLocalStorage(key, str) {
    localStorage.setItem(key, str);
  }

  getLocalStorage(key) {
    return localStorage.getItem(key);
  }

  removeLocalStorage(key) {
    localStorage.removeItem(key);
  }
}
